import * as React from 'react';
import {
    FormControl, InputLabel, Input, Select, MenuItem,
    Grid,
    IconButton,
    Typography
} from '@material-ui/core';
// import { Redirect } from 'react-router';
// import { Link } from 'react-router-dom';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import { ModuleType } from 'src/constants/Enum/ModuleEnum';

export default class AddModule extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isGISelected: true,
            editModuleMetadata: {},
            moduleName: '',
            moduleDescription: '',
            moduleTypeId: ModuleType.GeneralInformation,
            moduleCategoryId: 1,
            showAddButton: true
        };
        this.handleModuleTypeChange = this.handleModuleTypeChange.bind(this);
        this.handleModuleCategoryChange = this.handleModuleCategoryChange.bind(this);
        this.handleName = this.handleName.bind(this);
        this.handleDescription = this.handleDescription.bind(this);
        this.saveModule = this.saveModule.bind(this);
        this.back = this.back.bind(this);
        this.handleQuestionAssignment = this.handleQuestionAssignment.bind(this);
    }

    componentDidMount() {
        const url = window.location.href.split('/');
        const paramIndex = window.location.href.split('/').indexOf("module");
        if (url[paramIndex + 1] === "") {
            this.setState({
                showAddButton: true
            })
        }
        else {
            this.setState({
                showAddButton: false
            })
        }
        if (this.props.editModuleMetadata.module) {
            this.setState({
                isGISelected: this.props.editModuleMetadata.module.module_type_id === ModuleType.GeneralInformation || this.props.editModuleMetadata.module.module_type_id === ModuleType.Forecast,
                editModuleMetadata: this.props.editModuleMetadata,
                moduleName: this.props.editModuleMetadata.module.name,
                moduleDescription: this.props.editModuleMetadata.module.description,
                moduleTypeId: this.props.editModuleMetadata.module.module_type_id,
                moduleCategoryId: this.props.editModuleMetadata.module.module_category_id
            });
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.editModuleMetadata !== this.props.editModuleMetadata) {
            this.setState({
                isGISelected: nextProps.editModuleMetadata.module.module_type_id === ModuleType.GeneralInformation || nextProps.editModuleMetadata.module.module_type_id === ModuleType.Forecast,
                editModuleMetadata: nextProps.editModuleMetadata,
                moduleName: nextProps.editModuleMetadata.module.name,
                moduleDescription: nextProps.editModuleMetadata.module.description,
                moduleTypeId: nextProps.editModuleMetadata.module.module_type_id,
                moduleCategoryId: nextProps.editModuleMetadata.module.module_category_id
            });
        }
    }
    handleModuleTypeChange(event: any) {
        const moduleTypeId = event.target.value;
        this.setState({
            moduleTypeId,
            isGISelected: moduleTypeId === ModuleType.GeneralInformation || moduleTypeId === ModuleType.Forecast,
            moduleCategoryId: (moduleTypeId === ModuleType.GeneralInformation || moduleTypeId === ModuleType.Forecast) ? null : this.state.moduleCategoryId
        },
            () => this.props.createUpdateModule({ data: this.state.moduleTypeId, field: 'moduleTypeId' })
        );
    }
    handleModuleCategoryChange(event: any) {
        const moduleCategoryId = event.target.value;
        this.setState({ moduleCategoryId },
            () => this.props.createUpdateModule({ data: this.state.moduleCategoryId, field: 'moduleCategoryId' })
        );
    }

    handleName(event: any) {
        const moduleName = event.target.value;
        this.setState({ moduleName },
            () => this.props.createUpdateModule({ data: this.state.moduleName, field: 'moduleName' })
        );

    }

    handleDescription(event: any) {
        const moduleDescription = event.target.value;
        this.setState({ moduleDescription },
            () => this.props.createUpdateModule({ data: this.state.moduleDescription, field: 'moduleDescription' })
        );
    }

    saveModule = () => {
        this.props.saveModule();
        // this.back();
    }
    back() {
        this.props.redirect('/modules');

    }
    handleQuestionAssignment = () => {
        this.props.redirect(`/module/questions/${this.props.editModuleMetadata.module.id}`);
    }
    render() {
        return (
            <>
                <div className="pageHeading">
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={3}>
                            <div className="pageTitleSection">
                                <IconButton onClick={this.back} className="backButton" color="inherit" aria-label="Open drawer">
                                    <IconBackButton />
                                </IconButton>
                                <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                    {!this.state.showAddButton ? 'Edit Module' : 'Create Module'}
                                </Typography>
                            </div>
                        </Grid>

                        <Grid item={true} xs={9}>

                            <div className="pagesLinks text-right">
                                {
                                    <ul>
                                        {this.state.showAddButton
                                            ?
                                            <>
                                                <li className="listItem" >
                                                    <a href="javascript:void(0)" className="primary" onClick={this.saveModule}>Save</a>
                                                </li>
                                            </>
                                            :
                                            <>
                                                <li className="listItem">
                                                    <a href="javascript:void(0)" className="primary" onClick={this.saveModule}>Update</a>
                                                </li>
                                                <li className="listItem">
                                                    <a href="javascript:void(0)" onClick={this.handleQuestionAssignment}>Assign Questions</a>
                                                </li>
                                            </>
                                        }
                                    </ul>

                                }
                            </div>

                        </Grid>
                    </Grid>
                </div>

                <div className="pageContent">
                    {
                        this.state.editModuleMetadata.module !== undefined && this.state.editModuleMetadata.moduleQuestion !== undefined
                        &&
                        <div className="contentSection">
                            <form className="registerForm mui-form-inline" noValidate={true} autoComplete="off" >
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <InputLabel htmlFor="name">Name</InputLabel>
                                    <Input id="name" value={this.state.moduleName ? this.state.moduleName : ''}
                                        name="name" autoComplete="name" autoFocus={true}
                                        onChange={this.handleName} />
                                </FormControl>
                                <FormControl margin="normal" fullWidth={true}>
                                    <InputLabel htmlFor="name">Description</InputLabel>
                                    <Input id="description" value={this.state.moduleDescription ? this.state.moduleDescription : ''}
                                        name="description" autoComplete="description" autoFocus={false}
                                        onChange={this.handleDescription} />
                                </FormControl>

                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <InputLabel htmlFor="module-type-auto-width">Module Types</InputLabel>
                                    <Select
                                        value={this.state.moduleTypeId}
                                        onChange={this.handleModuleTypeChange}
                                        input={<Input name="moduletype" id="module-type-auto-width" />}
                                        autoWidth={false}
                                    >
                                        {this.state.editModuleMetadata.moduleQuestion.module_types.map((mt: any) => {
                                            return (
                                                <MenuItem key={mt.key} value={mt.key}>{mt.value}</MenuItem>
                                            )
                                        })
                                        }
                                    </Select>
                                </FormControl>

                                <FormControl margin="normal" fullWidth={true}>
                                    <InputLabel htmlFor="module-cat-auto-width">Module Categories</InputLabel>
                                    <Select
                                        value={this.state.moduleCategoryId === null ? 0 : this.state.moduleCategoryId}
                                        onChange={this.handleModuleCategoryChange}
                                        input={<Input name="modulecategory" id="module-cat-auto-width" />}
                                        autoWidth={false}
                                        disabled={this.state.isGISelected}
                                    >
                                        {
                                            this.state.editModuleMetadata.moduleQuestion.module_categories.map((mt: any) => {
                                                return (
                                                    <MenuItem key={mt.key} value={mt.key}>{mt.value}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                {/* {   this.state.showAddButton 
                                ? 
                                    <Button className="primary" onClick={this.saveModule}>Save</Button>
                                :
                                <>
                                    <Button className="primary" onClick={this.saveModule}>Update</Button>
                                    
                                    <Link to={{ pathname: `/module/questions/${this.props.editModuleMetadata.module.id}` }}>Assign Questions</Link >
                                </>
                            } */}



                            </form></div>
                    }
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/AddModuleComponent.tsx